import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

let _uid = 0;

/**
 * BrandLogo — the single AppliedBioX lockup, inlined as SVG so apps stop
 * duplicating `logo-horizontal[-dark].svg` into every assets folder (the source
 * of the per-app brand drift, e.g. the stale `#5B7A8E` tagline).
 *
 * - `variant="light"` — navy wordmark + amber X, for light surfaces (nav, login).
 * - `variant="dark"`  — luminous water-drop + white wordmark + bright-amber X, for
 *   ocean surfaces (sidebars, headers, footers, splash). The drop uses a
 *   lit-from-within gradient so it never dissolves into the navy background.
 * - `markOnly`        — just the water-drop glyph (square).
 * - `height`          — rendered height in px (width derives from the aspect ratio).
 */
@Component({
  selector: 'bodyanalytics-brand-logo',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './brand-logo.component.html',
  styleUrls: ['./brand-logo.component.scss'],
})
export class BrandLogoComponent {
  variant = input<'light' | 'dark'>('light');
  markOnly = input(false);
  height = input(38);

  /** Unique-per-instance suffix so multiple logos on a page don't share gradient ids. */
  protected readonly uid = `bl${_uid++}`;
  protected readonly isDark = computed(() => this.variant() === 'dark');
  /** width from aspect ratio: full lockup viewBox is 400×100 (4:1), mark is 80×80 (1:1). */
  protected readonly width = computed(() => (this.markOnly() ? this.height() : this.height() * 4));
  protected readonly label = computed(() => 'AppliedBioX — hydrostatic body composition');
}
